import NovelBox from 'component/NovelBox'
import { Wrapper } from './Styled'
import { memo } from 'react'

interface Template307Props {
  videoData?: any[]
}

// 豎版三個半向左滑動
function Template307({ videoData }: Template307Props) {
  return (
    // 因這裡有滑動事件, 設定.swiper-no-swiping 禁止CMS View的左右滑動切換頻道功能
    <Wrapper className={'swiper-no-swiping'}>
      {videoData?.map((item, i) => {
        return <NovelBox overflow={true} key={i} novelInfo={item} columns={3.5} allowUnload />
      })}
    </Wrapper>
  )
}

export default memo(Template307)
